import PostRequest from "../../services/PostRequest";

export const ASIN_LIST = "ASIN_LIST";
export const GET_MORE_ASIN_LIST = "GET_MORE_ASIN_LIST";
export const ASIN_OPEN = "ASIN_OPEN";
export const ASIN_VIEW_DETAILS = "ASIN_VIEW_DETAILS";
export const PLAY_GROUND_CREATE = "PLAY_GROUND_CREATE";

export const getAsinList = (data, isMoreAsins = false) => {
  return async (dispatch) => {
    try {
      const response = await PostRequest("/schedules/asin/list/", data);

      if (isMoreAsins) {
        dispatch({
          type: GET_MORE_ASIN_LIST,
          value: response,
        });
      } else {
        dispatch({
          type: ASIN_LIST,
          value: response,
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const setAsin = (data = false) => {
  return async (dispatch) => {
    dispatch({
      type: ASIN_OPEN,
      value: data,
    });
  };
};

export const asinView = (data = false) => {
  return async (dispatch) => {
    try {
      if (data) {
        const response = await PostRequest("/schedules/asin/get/", data);
        dispatch({
          type: ASIN_VIEW_DETAILS,
          value: response,
        });
      } else {
        dispatch({
          type: ASIN_VIEW_DETAILS,
          value: false,
        });
      }
    } catch (error) {
      console.log("error", error.message);
      dispatch({
        type: ASIN_VIEW_DETAILS,
        value: false,
      });
    }
  };
};

export const playgroundCreate = (response) => {
  return (dispatch) => {
    dispatch({
      type: PLAY_GROUND_CREATE,
      value: response,
    });
  };
};
